import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CleanersPage from "../pages/cleaners/page";
import BookingPage from "../pages/booking/page";
import LoginPage from "../pages/auth/login/page";
import SignupPage from "../pages/auth/signup/page";
import DashboardOverviewPage from "../pages/dashboard/overview/page";
import DashboardBookingsPage from "../pages/dashboard/bookings/page";
import DashboardCleanersPage from "../pages/dashboard/cleaners/page";
import DashboardBillingPage from "../pages/dashboard/billing/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminOverviewPage from "../pages/admin/overview/page";
import AdminBookingsPage from "../pages/admin/bookings/page";
import AdminCleanersPage from "../pages/admin/cleaners/page";
import AdminCustomersPage from "../pages/admin/customers/page";
import AdminPayoutsPage from "../pages/admin/payouts/page";
import AdminSettingsPage from "../pages/admin/settings/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cleaners",
    element: <CleanersPage />,
  },
  {
    path: "/booking",
    element: <BookingPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/signup",
    element: <SignupPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardOverviewPage />,
  },
  {
    path: "/dashboard/bookings",
    element: <DashboardBookingsPage />,
  },
  {
    path: "/dashboard/cleaners",
    element: <DashboardCleanersPage />,
  },
  {
    path: "/dashboard/billing",
    element: <DashboardBillingPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: <AdminOverviewPage />,
  },
  {
    path: "/admin/bookings",
    element: <AdminBookingsPage />,
  },
  {
    path: "/admin/cleaners",
    element: <AdminCleanersPage />,
  },
  {
    path: "/admin/customers",
    element: <AdminCustomersPage />,
  },
  {
    path: "/admin/payouts",
    element: <AdminPayoutsPage />,
  },
  {
    path: "/admin/settings",
    element: <AdminSettingsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;